<template>
  <dl class="gap-16 md:columns-2">
    <div
      v-for="(spec, index) in specifications"
      :key="index"
      class="border-static-default-low flex items-center justify-between border-t py-12 first:border-t-0"
      :class="{
        'border-t md:border-t-0': index % 3 === 0,
      }"
    >
      <dt class="text-static-default-low body-2 text-nowrap">
        <span v-if="isColorSpec(spec)">
          {{ i18n(translations.colorsLabel) }}
        </span>
        <span v-else-if="isStorageSpec(spec)">
          {{ i18n(translations.storageLabel) }}
        </span>
        <span v-else>{{ spec.label }}</span>
      </dt>
      <dd>
        <ColorSwatches
          v-if="isColorSpec(spec)"
          class="mt-4"
          :colors="spec.value"
        />
        <StorageTags
          v-else-if="isStorageSpec(spec)"
          :max-tags="2"
          :storages="spec.value"
        />
        <span v-else>{{ spec.value }}</span>
      </dd>
    </div>
  </dl>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '~/scopes/recommendation/components/ProductCard.translations'

import ColorSwatches from './ColorSwatches.vue'
import StorageTags from './StorageTags.vue'

const i18n = useI18n()

interface BaseSpec {
  label: string
  value: string
}

interface ColorSpec {
  label: 'color'
  value: Array<{ name: string; value: string }>
}

interface StorageSpec {
  label: 'storage'
  value: string[]
}

export type Spec = BaseSpec | ColorSpec | StorageSpec

defineProps<{ specifications: Array<Spec> }>()

function isColorSpec(spec: Spec): spec is ColorSpec {
  return spec.label === 'color'
}
function isStorageSpec(spec: Spec): spec is StorageSpec {
  return spec.label === 'storage'
}
</script>
